import { render } from "./PhotoClassifyLineTinyProp.vue?vue&type=template&id=e80a56b0&scoped=true"
import script from "./PhotoClassifyLineTinyProp.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyLineTinyProp.vue?vue&type=script&lang=js"

import "./PhotoClassifyLineTinyProp.vue?vue&type=style&index=0&id=e80a56b0&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80a56b0"]])

export default __exports__